import { createFileRoute } from "@tanstack/react-router"

import { Module } from "~/components/design-system/pages"
import { SeasonsCollectionsProvider } from "~/components/prototype/seasons-collections/SeasonsCollectionsContext"
import {
  SeasonsCollectionsActions,
  SeasonsCollectionsPage,
} from "~/components/prototype/seasons-collections/SeasonsCollectionsPage"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { usePageTracking } from "~/hooks/usePageTracking"
import { internalRouteGuard } from "~/utils/routeGuards"

export const Route = createFileRoute("/_auth/prototype/seasons-collections/")({
  staticData: { skipSkuStoreData: true },
  beforeLoad: internalRouteGuard,
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Prototype: Seasons and collections")
  // Above <Module>: the inspector is rendered by Module itself, so it needs the provider too.
  return (
    <SeasonsCollectionsProvider>
      <Module
        breadcrumb={<BreadcrumbWrapper items={[{ label: "Seasons and collections" }]} />}
        actions={<SeasonsCollectionsActions />}
      >
        <SeasonsCollectionsPage />
      </Module>
    </SeasonsCollectionsProvider>
  )
}
